import React from 'react'
import SupplyBillAgreeIco from '../../view/items/SupplyBillAgreeIco'
import Person4Icon from '@mui/icons-material/Person4';
import { useState } from 'react';
import MyModal from '../../../../UI/modal/MyModal';
import AgreeDeputyDirectorSupplyBillItemForm from './AgreeDeputyDirectorSupplyBillItemForm';
import Diversity2Icon from '@mui/icons-material/Diversity2';

const AgreeDeputyDirectorSupplyButton = ({ supplyBillItem }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <SupplyBillAgreeIco
            onClick={e => setOpen(true)}
            text={'Погодження зам директора постачання'}
            ico={<Diversity2Icon />}
            value={supplyBillItem.isAgreeDeputyDirectorSupply}
        />

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Погодження'}
            disableClickOutside={true}
            content={
                <AgreeDeputyDirectorSupplyBillItemForm
                    // supplyOrderId={supplyOrderId}
                    supplyBillItemBd={supplyBillItem}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default AgreeDeputyDirectorSupplyButton